import { Link, useNavigate } from 'react-router-dom'
import { Breadcrumbs } from './Breadcrumbs'
import './navigation.css'

/**
 * Contextual navigation: back link, breadcrumbs, and quick actions between pages.
 */
export function PageContextBar({ breadcrumbs = [], backTo, backLabel = 'Tilbage', actions = [] }) {
  const navigate = useNavigate()

  const handleBack = (e) => {
    if (backTo) return
    e.preventDefault()
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate('/')
    }
  }

  return (
    <div className="page-context">
      <div className="page-context-row">
        {backTo ? (
          <Link to={backTo} className="page-back">
            ← {backLabel}
          </Link>
        ) : (
          <button type="button" className="page-back" onClick={handleBack}>
            ← {backLabel}
          </button>
        )}
        <Breadcrumbs items={breadcrumbs} />
      </div>
      {actions.length > 0 && (
        <div className="page-actions">
          {actions.map((action) => (
            <Link
              key={action.label}
              to={action.to}
              className={'page-action-link' + (action.primary ? ' primary' : '')}
            >
              {action.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
